import { render, staticRenderFns } from "./ai-playwright-settings.vue?vue&type=template&id=44c2f88e&scoped=true"
import script from "./ai-playwright-settings.vue?vue&type=script&lang=js"
export * from "./ai-playwright-settings.vue?vue&type=script&lang=js"
import style0 from "./ai-playwright-settings.vue?vue&type=style&index=0&id=44c2f88e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2f88e",
  null
  
)

export default component.exports